<div ref="favMapContainer"
     data-isloaded="false"
     style=" width: 100%;" :style="showMap ? {'height': '500px'} : {'height': '0'}"
></div>
